import { Collection, fromJS, Map } from 'immutable'
import { GET_DEPARTMENT_PICKUP_SERVICES_FROM_MATRIX, ROUTER_LOCATION_CHANGE_ACTION } from '../actions/actionTypes'
import { AnyData } from '../actions/creators/baseHelpers'
import { ImmutableMap } from '../types/immutableTypes'

interface ServicesFromMatrixState {
  pickupServices: Collection<unknown, unknown>
  errors: unknown
}

interface ActionProp {
  type: string
  body: AnyData
}

interface ServicesFromMatrixStateImmutable extends ImmutableMap<ServicesFromMatrixState> {}

const initialState: ServicesFromMatrixStateImmutable = Map({
  pickupServices: Map(),
  deliveryServices: Map(),
  errors: []
} as ServicesFromMatrixState)

export default (
  state: ServicesFromMatrixStateImmutable = initialState,
  action: ActionProp
): ServicesFromMatrixStateImmutable => {
  switch (action.type) {
    case GET_DEPARTMENT_PICKUP_SERVICES_FROM_MATRIX.SUCCESS:
      return state.withMutations((s) =>
        s.set('pickupServices', fromJS(action.body.services)).set('errors', fromJS(action.body?.errors ?? []))
      )
    case ROUTER_LOCATION_CHANGE_ACTION:
      return initialState
    default:
      return state
  }
}
